<template>
  <div class="voer_warp">
    <!-- 区域汇总 -->
    <ZklDistrbution />
    <div class="she_ward">
      <el-card>
        <div class="flex">
          <!-- 区域概览 -->
          <ZKLQiaolianFenbu />
        </div>
      </el-card>
    </div>

    <!--  -->
    <div class="box_flex">
      <div class="lefet">
        <ZKLBoybili />
      </div>
      <div class="rigth_end">
        <ZKLShiLingLaodong />
      </div>
    </div>
    <!-- 企业数量就业人数分行业门类分析 -->
    <ZKLBoyGir />
    <!-- 各行业中企央企数量分析 -->
    <ZKLSheqv />
    <!-- 企业税收分段统计  企业类型统计 -->
    <div class="box_flexuser">
      <div class="lefet">
        <ZKLqiye />
      </div>
      <div class="rigth_end">
        <ZKLtongji />
      </div>
    </div>
    <!-- 企业注册地与经营地情况统计 -->
    <ZklRegistration />
    <!--  -->
    <zklOnfocus />
  </div>
</template>

<script>
import ZklDistrbution from "./cnps/Zkl-distrbution.vue";
import ZKLQiaolianFenbu from "./cnps/ZKl-qiaoQIFenBu.vue";
import ZKLSheqv from "./cnps/Zkl-sheQv.vue";
import ZKLBoyGir from "./cnps/Zkl-boyGir.vue";
import ZKLBoybili from "./cnps/Zkl-boyBili.vue";
import ZKLShiLingLaodong from "./cnps/Zkl-shiLingLaodogn.vue";
import ZKLqiye from "./cnps/ZKLqiye.vue";
import ZKLtongji from "./cnps/ZKLtongji.vue";
import ZklRegistration from "./cnps/Zkl-Registration.vue";
import zklOnfocus from "./cnps/Zkl-onfocus.vue";
export default {
  components: {
    ZklDistrbution,
    ZKLQiaolianFenbu,
    ZKLSheqv,
    ZKLBoyGir,
    ZKLBoybili,
    ZKLShiLingLaodong,
    ZKLqiye,
    ZKLtongji,
    ZklRegistration,
    zklOnfocus,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.voer_warp {
  .she_ward {
    padding: 10px 0;
    .flex {
      display: flex;
    }
  }
  .box_flex {
    display: flex;
    height: 450px;
    justify-content: space-between;
    margin: 10px 0 15px 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    background: #fff;
    .lefet {
      width: 50%;
      height: 100%;
    }
    .rigth_end {
      width: 50%;
      height: 100%;
    }
  }
  .box_flexuser {
    display: flex;
    height: 450px;
    justify-content: space-between;
    margin: 10px 0 15px 0;

    .lefet {
      width: 49%;
      height: 100%;
    }
    .rigth_end {
      width: 50%;
      height: 100%;
    }
  }
}
</style>
